// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"oKo5fRTbaa_CF29tHJmo_","icon":"_1E4pWYHn_eUlu5oBmc8guT","rightEl":"_389JzuOheTbV2OuegDbliu","highlighted":"_3Pfte7HdA8GV85puO496ou","text":"_2eLdtd6iP3WKo16fq9ieP5"};